import { createFileRoute, redirect } from '@tanstack/react-router';

import { SharePublicPageLink } from '~pages/settings/public-page-link';
import { checkMinRoleValue } from '~shared/utils/role-guard';
import { UserRoles } from '~entities/users';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/_layout/public-page-link')({
  beforeLoad: async () => {
    // Studio Admins+ manage the public schedule landing link (ENR-698).
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: SharePublicPageLink,
});